import moment from "moment";

const timeFromNow = (timeFrom, formatParameter = "minutes") => {
  const currentTime = moment();
  const fromTime = moment().subtract(timeFrom, formatParameter);
  return fromTime.from(currentTime);
};

export default timeFromNow;
